/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .controller('AccountController', [
        '$scope',
        '$modalInstance',
        'operationComplete',
        'AccountNotifications',
        'AccountNotificationsShares',
        'editNotificationShare',
        'CloudPlatformIdentityProvider',
        function (
            $scope,
            $modalInstance,
            operationComplete,
            AccountNotifications,
            AccountNotificationsShares,
            editNotificationShare,
            CloudPlatformIdentityProvider
        ) {
            const actions = {
                updateDetails: () => {
                    $scope.account.$updateDetails();
                    $modalInstance.dismiss('cancel');
                },
            };

            const loadShares = () => AccountNotificationsShares.query({}, (shares) => $scope.account.notificationShares = shares);

            const loadNotifications = () => {
                $scope.modal.loading = true;
                AccountNotifications.get({}, (defaultNotifications) => {
                    $scope.account.notificationDefault = defaultNotifications;
                    $scope.modal.loading = false;
                });
            };

            $scope.modal = $modalInstance.options;

            $modalInstance.opened.then(() => {
                if ($scope.modal.action == 'updateDetails') {
                    $scope.reloadSessionData();
                }
            });

            if ($scope.modal.action == 'updateDetails') {
                CloudPlatformIdentityProvider.canChangeCloudPlatformName()
                    .then((canChangeCloudPlatformName) => $scope.canEditAccountName = canChangeCloudPlatformName)
                    .catch(() => $scope.canEditAccountName = false);
            }

            if ($scope.modal.action == 'manageNotifications') {
                loadNotifications();
                loadShares();
            }

            $scope.$on('reload_shares', () => loadShares());

            $scope.ok = () => {
                const action = $modalInstance.options.action;

                angular.isFunction(actions[action]) ?
                    actions[action]() :
                    $modalInstance.dismiss('cancel');
            };

            $scope.close = $scope.cancel = () => $modalInstance.dismiss('cancel');

            $scope.editNotificationShare = (share) => editNotificationShare.showDialog(share);

            $scope.removeNotificationShare = (share) => angular.copy(share).$delete({
                uuid: `${share.user_uuid},${share.node_uuid}`
            })
                .then(() => {
                    operationComplete("notifications_removed_for_share_success_message", { share: share.name });
                    loadShares();
                });

            $scope.updateDefaultNotifications = (applyToAllShares) => AccountNotifications.saveDefaults({
                apply_all_shares: applyToAllShares,
                notification_default: $scope.account.notificationDefault
            }).$promise
                .then(() => {
                    operationComplete('Successfully saved notification settings.');

                    if (applyToAllShares) {
                        loadShares();
                    }
                });

            $scope.disableSubmit = () => $scope.modal.action == 'updateDetails' && $scope.account.name == '';

            $scope.getCloseButtonLabel = () => $scope.canEditAccountName ? 'Cancel' : 'Close';
        }
    ]);
